import { useTranslation } from 'react-i18next';

import PageLayout from '~layouts/page/pageLayout';

import CreateWebhookContainer from '../containers/createWebhookContainer';

const CreateWebhookPage = () => {
	const { t } = useTranslation();

	return (
		<PageLayout
			pageTitle={t('webhook.labels.single', { ns: 'entities' })}
			headerInfo={{
				title: t('webhook.labels.single', { ns: 'entities' }),
			}}
		>
			<CreateWebhookContainer />
		</PageLayout>
	);
};

export default CreateWebhookPage;
